<script>
  import AttributeDropdown from "./attributeDropdown.svelte"
  export let parsedJson
  export let disableAttributeBtn
  let activeItem
  let tempJson
</script>

<div class="grid w-4/6 grid-cols-1 gap-2 p-2">
  <AttributeDropdown bind:disableAttributeBtn dropdownItems={Object.keys(parsedJson)} {parsedJson} {activeItem} bind:tempJson />
</div>
